import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  sender_name: 'Nombre del remitente',
  sender_wallet: 'Billetera del remitente',
  last_n_digits: 'Referencia de transacción',
  invoice_flow__multi_time_remainin: 'Tiempo restante',
  invoice_flow__multi_or: 'O',
  invoice_flow__multi_copy_code: 'Copiar código',
  invoice_flow__multi_open_app: 'Abrir en la aplicación',
  invoice_flow__multi_return_button: 'Volver al sitio web',
  invoice_flow__card_transfer_button: 'Confirmar',
  invoice_flow__multi_bank_transfer_step_1: 'Copiar los requisitos',
  invoice_flow__multi_bank_transfer_step_2: 'Realizar un pago',
  invoice_flow__multi_step_3:
    'Confirma el pago proporcionando la <b>{attributes}</b> y presiona el botón "Confirmar"',
  payer_document_id: 'Cédula de identidad',
  payer_bank_code: 'Código de banco',
  payer_phone: 'Teléfono',
  transaction_reference: 'Referencia de transacción (últimos 8 dígitos)',
};
